import urls from "../services/constants.json"

export const get_relatory_url = () => {
    // if(urls.WSSERVER.includes("localhost")) return "localhost"
    
    return "contas."
}
